import { IssueTypeAttachmentService as OvermapIssueTypeAttachmentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class IssueTypeAttachmentService extends OvermapIssueTypeAttachmentService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
